const baseMixin = {
	methods: {
		plural(singular, plural, nb) {
			if (nb == 1) {
                return singular;
            }
            return plural;
		},

		isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        }
	}
}